import { render } from "./GarantiaCrediario.vue?vue&type=template&id=96d33b2a&scoped=true"
import script from "./GarantiaCrediario.vue?vue&type=script&lang=js"
export * from "./GarantiaCrediario.vue?vue&type=script&lang=js"

import "./GarantiaCrediario.vue?vue&type=style&index=0&id=96d33b2a&scoped=true&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96d33b2a"]])

export default __exports__